<template>
  <button
    v-tooltip="{ content: tooltip }"
    type="button"
    role="button"
    class="t-group-button box-border inline-flex h-8 min-w-8 cursor-pointer items-center justify-center border-2 border-solid border-transparent py-1.5 font-inter text-xs font-medium transition duration-300 first:rounded-l-md last:rounded-r-md focus:border-accent-1 disabled:!cursor-not-allowed disabled:!border-transparent"
    :class="{
      'bg-gray-500 text-gray-100 hover:bg-gray-400 hover:text-gray-50 focus:bg-gray-600 focus:text-gray-10 disabled:!bg-gray-600 disabled:!text-gray-200':
        !inverse,
      'bg-[color-mix(in_srgb,var(--c-g100)_80%,var(--c-g10))] text-gray-400 hover:bg-[color-mix(in_srgb,var(--c-g200)_80%,var(--c-g10))] hover:text-gray-600 focus:bg-[color-mix(in_srgb,var(--c-g100)_15%,var(--c-g10))] focus:text-gray-800 disabled:!brightness-110':
        inverse,
      '!border-accent-1 !bg-gray-800 !text-gray-10': active && !inverse,
      '!border-accent-1 !bg-[color-mix(in_srgb,var(--c-g100)_15%,var(--c-g10))] !text-gray-500':
        active && inverse,
      '!h-6 !w-6 !min-w-6': extraSmall && !$slots.text,
      'w-8': small && !$slots.text,
      'w-11': medium && !$slots.text,
      'w-15': large && !$slots.text,
      'w-[130px]': xl && !$slots.text,
      'px-1.5': $slots.text,
    }"
    :disabled="disabled"
    @click="btnClicked"
  >
    <slot></slot>
    <span v-if="$slots.text" class="pl-1">
      <slot name="text"></slot>
    </span>
  </button>
</template>

<script lang="ts" setup>
const props = defineProps<{
  active?: boolean;
  toggle?: boolean;
  data?: string;
  flat?: boolean;
  extraSmall?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  xl?: boolean;
  disabled?: boolean;
  tooltip?: string;
  inverse?: boolean;
}>();

const emit = defineEmits(["button-clicked"]);

function btnClicked() {
  if (!props.disabled) {
    if (props.toggle && props.active) {
      emit("button-clicked", "");
    } else {
      emit("button-clicked", props.data);
    }
  }
}
</script>
